import { ALL_VIEWS } from "../inference/detector.js";
import { TemporalSmoother } from "../inference/smoothing.js";

const MISSES_BEFORE_EMPTY = 2;

export class LiveAnalyzer {
  constructor(classifier, video, { intervalMs = 400, detector = null, onUpdate = () => {}, onEmpty = () => {},
    onError = () => {} } = {}) {
    this.classifier = classifier;
    this.video = video;
    this.intervalMs = intervalMs;
    this.detector = detector;
    this.onUpdate = onUpdate;
    this.onEmpty = onEmpty;
    this.onError = onError;
    this.smoother = new TemporalSmoother(0.35);
    this.timer = null;
    this.busy = false;
    this.samples = [];
    this.misses = 0;
  }

  get running() {
    return this.timer !== null;
  }

  start() {
    this.stop();
    this.smoother.reset();
    this.samples = [];
    this.misses = 0;
    this.timer = setInterval(() => this.tick(), this.intervalMs);
  }

  async tick() {
    if (this.busy || this.video.readyState < 2) return;
    this.busy = true;
    try {
      const detection = this.detector?.ready
        ? await this.detector.find(this.video, this.onError, this.misses ? ALL_VIEWS : ["whole"])
        : null;
      if (detection && !detection.dogs.length) {
        this.misses += 1;
        if (detection.empty && this.misses >= MISSES_BEFORE_EMPTY) {
          this.smoother.reset();
          this.onEmpty(detection);
          return;
        }
      } else if (detection) {
        this.misses = 0;
      }
      const probs = await this.classifier.probabilities(this.video, "center");
      this.samples.push(probs);
      const smoothed = this.smoother.push(probs);
      this.onUpdate(this.classifier.describe(smoothed), this.smoother.frames, detection);
    } catch (error) {
      this.stop();
      this.onError(error);
    } finally {
      this.busy = false;
    }
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}
